import React from 'react';
import { usePropsContext } from 'src/hooks/usePropsContext';
import { StyledSelectInput } from '../StyledSelectInput';

export const OrganizationalType = () => {
  const {
    modelPrefix,
    onBlur,
    organizationTypes,
    orgTypeFlag,
    typesSubText,
    typesErrorPlaceholder,
  } = usePropsContext();
  const orgTypes =
    modelPrefix === 'facility'
      ? organizationTypes.facilityList
      : organizationTypes.alliedAncillaryList;

  return (
    <StyledSelectInput
      labelKey="referenceDescription"
      valueKey="referenceCode"
      data-testid="organizationType"
      label="Organization type"
      model={`${modelPrefix}.organizationTypeCode`}
      placeholder={orgTypeFlag.isError ? typesErrorPlaceholder : ''}
      subText={orgTypeFlag.isError ? typesSubText : ''}
      validators={{
        // Only display 'Please select a value' when there isn't an error
        required: orgTypeFlag.isError ? '(!)' : 'Please select a value',
      }}
      options={orgTypes}
      isError={orgTypeFlag.isError}
      width="50%"
      enableOutsideScroll
      onBlur={() => onBlur(`${modelPrefix}.organizationTypeCode`)}
    />
  );
};
